<script setup lang="ts">
import type { Icon } from '../HugeIcon/huge-icon';
import HugeIcon from '../HugeIcon/HugeIcon.vue';

const props = defineProps<{
  label: string;
  size?: 'md' | 'sm';
  icon?: Icon;
  variant?: 'primary' | 'secondary';
}>();

const emits = defineEmits<{
  click: [];
}>();
</script>

<template>
  <button
    :class="[
      'inline-flex items-center gap-1 rounded-lg font-semibold transition-all duration-300',
      props.size === 'md' ? 'text-md px-4 py-2' : 'px-3 py-1.5 text-sm',
      props.variant === 'primary' &&
        'bg-gradient-to-tr from-violet-600 to-indigo-600 text-white shadow-[0_4px_15px_rgba(147,51,234,0.4)] ease-[cubic-bezier(0.4,0,0.2,1)] hover:translate-y-[-1px] hover:shadow-[0_8px_25px_rgba(147,51,234,0.5)] hover:brightness-110 active:translate-y-[1px] active:shadow-[0_2px_10px_rgba(147,51,234,0.3)]',
      props.variant === 'secondary' &&
        'border border-slate-200 bg-slate-50 text-slate-800',
    ]"
    @click="emits('click')"
  >
    <HugeIcon
      v-if="props.icon"
      :icon="props.icon"
      :size="props.size === 'sm' ? 20 : 24"
    />
    {{ props.label }}
  </button>
</template>
